// extracted by mini-css-extract-plugin
module.exports = {"faqContentBox":"highlight-block_faqContentBox__wv2JK","contentTitle":"highlight-block_contentTitle__ybK96"};